import { render, staticRenderFns } from "./ScoreDialog.vue?vue&type=template&id=0ddb586e&scoped=true&"
import script from "./ScoreDialog.vue?vue&type=script&lang=js&"
export * from "./ScoreDialog.vue?vue&type=script&lang=js&"
import style0 from "./ScoreDialog.vue?vue&type=style&index=0&id=0ddb586e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddb586e",
  null
  
)

export default component.exports